export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GruposDisponiblesPage.vue?vue&type=template&id=4bf2858b&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/inscripciones/GruposDisponiblesPage.vue?vue&type=template&id=4bf2858b&scoped=true&
// module id = 669
// module chunks = 24